import { render, staticRenderFns } from "./SampleOrderInvoicePdfPopUp.vue?vue&type=template&id=38d56770&scoped=true&"
import script from "./SampleOrderInvoicePdfPopUp.vue?vue&type=script&lang=js&"
export * from "./SampleOrderInvoicePdfPopUp.vue?vue&type=script&lang=js&"
import style0 from "./SampleOrderInvoicePdfPopUp.vue?vue&type=style&index=0&id=38d56770&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d56770",
  null
  
)

export default component.exports